import { Wallet, Truck } from 'lucide-react';
import { cn } from '@/lib/utils';

export type DashboardView = 'financial' | 'logistics';

interface Props {
  value: DashboardView;
  onChange: (v: DashboardView) => void;
}

const OPTIONS: Array<{
  id: DashboardView;
  label: string;
  description: string;
  icon: React.ComponentType<{ className?: string }>;
}> = [
  {
    id: 'financial',
    label: 'Financeiro',
    description: 'Caixa, DRE, contas',
    icon: Wallet,
  },
  {
    id: 'logistics',
    label: 'Logística',
    description: 'Pedidos, estoque, vendas',
    icon: Truck,
  },
];

export function DashboardToggle({ value, onChange }: Props) {
  return (
    <div
      className="inline-flex p-1 rounded-2xl bg-surface-subtle border border-border"
      role="tablist"
      aria-label="Selecionar dashboard"
    >
      {OPTIONS.map((opt) => {
        const active = opt.id === value;
        return (
          <button
            key={opt.id}
            role="tab"
            aria-selected={active}
            onClick={() => onChange(opt.id)}
            className={cn(
              'flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium transition-all',
              active
                ? 'bg-brand-900 text-ink-inverse shadow-soft'
                : 'text-ink-muted hover:text-ink'
            )}
          >
            <opt.icon className="w-4 h-4" />
            <span className="font-display">{opt.label}</span>
            <span
              className={cn(
                'hidden md:inline text-xs font-normal',
                active ? 'text-brand-200' : 'text-ink-soft'
              )}
            >
              · {opt.description}
            </span>
          </button>
        );
      })}
    </div>
  );
}
